<template lang="pug">
    v-container#page404
        v-row.text-center(justify="center" style="position:absolute")
            v-col(cols="12")
                .circle

        v-row.text-center
            v-col(cols="12")
                v-row(justify="center")
                    .display-1.font-weight-bold.sumup.mb-10 
                        v-img(contain src="@/assets/images/logo.png" max-height="50")
                v-row(justify="center")
                    .display-1.font-weight-bold.sumup.mb-10 
                        v-img(contain src="@/assets/images/404page.png" max-height="500")
                v-row(justify="center")
                    .mb-10(style="z-index:99") 
                        .title.font-weight-bold 我們現在找不到此頁面 
                        .title.font-weight-bold 可能是網址有誤或連結已失效

                v-row(justify="center")
                    .mb-10(style="z-index:99") 
                        span 返回 
                        a(@click="back") 上一頁
                
</template>
<script>
export default {
  data() {
    return {
      prevPath: ""
    }
  },
  methods: {
    back() {
      this.$router.go(-1)
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.prevPath = from.path
    })
  },
  beforeRouteLeave(to, from, next) {
    if (to.path == this.prevPath) {
      next("/")
    } else {
      next()
    }
  }
}
</script>
<style lang="scss" scoped>
.circle {
  left: 50%;
  width: 120vh;
  height: 120vh;
  border-radius: 60vh;
  background-color: #fdf1eb;
  position: fixed;
  margin-left: -60vh;
  margin-top: -10vh;
}
</style>
